const perFile = {
  state: {
    appnav: []
  },

  mutations: {
    APPNAV(state, data) {
      state.appnav = data;
    }
  },

  actions: {
    appnav({ commit }, data) {
      console.log(data, "app导航");
      commit("APPNAV", data);
    }
  }
};

export default perFile;
